import i18n from "i18next";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import BundleSummary from "@/Pages/BuyFlow/BundleSummary";
import CustomBundleSummary from "@/Pages/BuyFlow/CustomBundleSummary";
import AddOnSummary from "@/Pages/BuyFlow/AddOnSummary";
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";
import BillingFrequency from "@/Pages/BuyFlow/BillingFrequency";
import notifyNativeApp from "@/Utilities/NotifyNativeApp";

export default function Summary({state, dispatch}) {
    return (
        <div className="buy-flow-summary">
            <div className="summary-container">
                <div className="summary-title">{i18n.t('buy-flow.summary')}</div>
                <div className="summary-items">
                    {state.cart.filter(item => item.type === "package").length > 0 &&
                        <BundleSummary state={state} dispatch={dispatch} />}
                    {state.cart.filter(item => item.type === "module").length > 0 &&
                        <CustomBundleSummary state={state} dispatch={dispatch} />}
                    {state.cart.length > 0 && <BillingFrequency state={state} dispatch={dispatch} />}
                    {state.cart.filter(item => item.type === "add-on").length > 0 &&
                        <AddOnSummary state={state} dispatch={dispatch} />}
                </div>
                <div className="summary-subtotal-buttons">
                    {state.cart.length > 0 && <div className="summary-subtotal-break" />}
                    <div className="summary-subtotal">
                        <span>
                            {i18n.t("buy-flow.subtotal")}
                        </span>
                        { state.step === 2 ?
                            <span className="summary-per-month">
                                {state.oneTimePrice > 0 && <>
                                    <span className="summary-price">${state.oneTimePrice}</span>
                                    <span className="per-month">{i18n.t("buy-flow./one-time")}</span>
                                </>}
                                {state.billingFrequency === "monthly" ?
                                    <div className="text-end">
                                        <span className="summary-price">
                                            ${state.totalPrice === 0 ? '--' : state.totalPrice}
                                        </span>
                                        <span className="per-month">{i18n.t("buy-flow./mo")}</span>
                                    </div> :
                                    <div className="text-end">
                                        <span className="summary-price">
                                            ${state.totalPrice === 0 ? '--' : state.totalPrice * 12}
                                        </span>
                                        <span className="per-month">{i18n.t("buy-flow./yr")}</span>
                                    </div> }
                            </span> :
                            state.billingFrequency === "monthly" ?
                                <span className="summary-per-month">
                                    <span className="summary-price">
                                        ${state.totalPrice === 0 ? '--' : state.totalPrice}
                                    </span>
                                    <span className="per-month">{i18n.t("buy-flow./mo")}</span>
                                </span> :
                                <span className="summary-per-month">
                                        <span className="summary-price">
                                            ${state.totalPrice === 0 ? '--' : state.totalPrice * 12}
                                        </span>
                                        <span className="per-month">{i18n.t("buy-flow./yr")}</span>
                                    </span>
                        }
                    </div>
                    <ButtonPrimary className="continue"
                                   disabled={state.cart.length === 0}
                                   dataQa="continue-button"
                                   onClick={() => dispatch({type: 'direction', payload: {direction: 'forward'}})
                                   }>
                        { state.step === 2 ?
                            i18n.t("buy-flow.checkout") :
                            i18n.t("buy-flow.continue") }
                    </ButtonPrimary>
                    { state.step === 2 ? <ButtonBorderless
                        className="borderless-back"
                        onClick={() => dispatch({type: 'direction', payload: {direction: 'backward'}})}
                        dataQa="back-button">
                        {i18n.t("buy-flow.back")}
                    </ButtonBorderless> : null }
                </div>
            </div>
        </div>
    )
}
